<template>
  <v-container>
    <v-row v-if="withinPeriod">
      <v-col cols="12">
        <div height="100%">
          <BaseStickyHeader
            v-if="contact && contact.Id > 0 && !loading"
            class="pt-2 pl-2"
          >
            <v-row class="pt-2 pl-2">
              <v-col cols="6" md="4">
                <ContactHeader
                  :canEdit="canEdit"
                  :contact="contact"
                  @refresh="refreshContact"
                  :expand="$vuetify.breakpoint.mdAndUp || expandHeader"
                ></ContactHeader>
              </v-col>
              <v-col cols="6" md="4">
                <PropertyHeader
                  v-if="property"
                  :property="property"
                  :canEdit="canEdit"
                  @refresh="refreshProperty"
                  :expand="$vuetify.breakpoint.mdAndUp || expandHeader"
                ></PropertyHeader>
              </v-col>
              <v-col cols="4">
                <div>
                  <div v-if="canSubmit" class="deadline-alert">
                    The application deadline for the
                    {{ currentLuPeriod.Period }} period is
                    {{
                      dayjs(currentLuPeriod.ApplicationDeadline).format(
                        'MM/DD/YYYY'
                      )
                    }}, make sure to complete and submit your application before
                    then
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="$vuetify.breakpoint.smAndDown">
              <v-col cols="12" align="center">
                <BaseTooltipButton
                  small
                  @click="expandHeader = !expandHeader"
                  iconColor="primary"
                  :icon="expandHeader ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                  >Expand
                </BaseTooltipButton>
              </v-col>
            </v-row>
          </BaseStickyHeader>
          <v-container fluid class="pa-0">
            <div>
              <div v-if="!loading && !haveContact">
                <v-row>
                  <v-col cols="12">
                    <h1 class="text-h4 primary--text">Contact</h1>
                    <h2 class="text-subtitle-1 primary--text pb-6"
                      >Please enter the following information
                      <BaseHelpTooltip
                        iconColor="primary"
                        tooltipText="Review Instructions"
                        header="Filing Instructions"
                        :maxWidth="850"
                        ><div><FilingInstructions></FilingInstructions> </div>
                      </BaseHelpTooltip>
                    </h2>
                  </v-col>
                </v-row>
                <ContactEntryForm
                  :canEdit="canEdit"
                  @itemAdded="$router.push({ query: { contactId: $event.Id } })"
                ></ContactEntryForm>
              </div>
              <div v-if="!loading && haveContact && !haveProperty"
                ><div v-if="!applicationDeadlineExpired">
                  <PropertyGrid
                    v-if="contactProperties.length > 0"
                    :contact="contact"
                    :properties="contactProperties"
                  ></PropertyGrid>
                  <PropertyEntryForm
                    v-if="contactProperties.length == 0"
                    :canEdit="canEdit"
                    :contact="contact"
                    @itemAdded="
                      $router.push({ query: { propertyId: $event.Id } })
                    "
                  ></PropertyEntryForm>
                </div>
                <v-card
                  class="mx-auto pa-6"
                  v-else-if="applicationDeadlineExpired"
                >
                  Application submissions for
                  {{ currentLuPeriod.Period }} refunds are no longer being
                  accepted.
                </v-card>
              </div>
              <div
                v-if="
                  !loading && haveContact && haveProperty && !haveApplication
                "
              >
                <ApplicationGrid
                  v-if="property.Applications.length > 0"
                  :applications="property.Applications"
                >
                </ApplicationGrid>
                <div
                  v-if="
                    propertyApplicationsForCurrentPeriod &&
                    propertyApplicationsForCurrentPeriod.length > 0
                  "
                  ><v-alert color="secondary white--text"
                    >An application exists for the current period</v-alert
                  ></div
                >
                <div v-if="!applicationDeadlineExpired">
                  <ApplicationForm
                    v-if="propertyApplicationsForCurrentPeriod.length == 0"
                    :property="property"
                    :canEdit="canEdit"
                    @itemAdded="
                      $router.push({
                        name: 'consumerForm',
                        params: { appId: $event.Id },
                      })
                    "
                    @updateIrsAttached="updateIRS($event)"
                  ></ApplicationForm>
                </div>
                <v-card
                  class="mx-auto pa-6"
                  v-else-if="applicationDeadlineExpired"
                >
                  Application submissions for
                  {{ currentLuPeriod.Period }} refunds are no longer being
                  accepted.
                </v-card>
              </div>
              <div v-if="!loading && haveApplication">
                <ApplicationDetails
                  :application="selectedApplication"
                  :canEdit="canEdit"
                ></ApplicationDetails>
              </div>
            </div>
          </v-container>
          <BaseDeleteConfirm
            ref="submitConfirm"
            :delete="goToNext"
            closeText="No"
            confirmText="Yes"
          >
            <div>
              You have not yet submitted your application. Do you still want to
              Exit?
            </div>
          </BaseDeleteConfirm>
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-card v-if="currentLuPeriod || errorMessage" class="mx-auto my-5 pa-8">
        <div v-if="currentLuPeriod">
          <div v-if="beforePeriod">
            The application period for {{ currentLuPeriod.Period }} refunds will
            open
            {{
              dayjs(currentLuPeriod.ApplicationOpenDate).format('MM/DD/YYYY')
            }}</div
          >
          <div v-if="applicationsAccepted">
            Application submissions for {{ currentLuPeriod.Period }} refunds
            will be accepted until
            {{
              dayjs(currentLuPeriod.ApplicationDeadline).format('MM/DD/YYYY')
            }}
          </div>
          <div v-if="applicationDeadlineExpired">
            <p>
              Application submissions for {{ currentLuPeriod.Period }} refunds
              are no longer being accepted. <br />
              Previously submitted applications can still have information added
              to them if it has been requested until the processing period ends
              on
              {{ dayjs(currentLuPeriod.PeriodEndDate).format('MM/DD/YYYY') }}.
            </p>
          </div>
          <div v-if="afterPeriod">
            The application period for {{ currentLuPeriod.Period }} refunds has
            closed
          </div>
        </div>
        <div v-else-if="errorMessage">{{ errorMessage }}</div>
      </v-card></v-row
    >
  </v-container>
</template>
<script>
import FilingInstructions from '@components/instructions.vue'
import { get, sync, commit, call } from 'vuex-pathify'
import dayjs from 'dayjs'
import ContactHeader from '@components/form/consumer/contactHeader'
import PropertyHeader from '@components/form/consumer/propertyHeader.vue'
import ContactEntryForm from '@components/form/consumer/contactEntryForm.vue'
import PropertyEntryForm from '@components/form/consumer/propertyEntryForm.vue'
import PropertyGrid from '@components/form/consumer/propertyGrid.vue'
import ApplicationDetails from '@components/form/consumer/applicationDetails.vue'
import ApplicationForm from '@components/form/consumer/applicationForm.vue'
import ApplicationGrid from '@components/form/consumer/applicationGrid.vue'
export default {
  //model: {
  //	prop: ''
  //},
  page() {
    let title = 'Form'
    if (this.selectedApplication && this.selectedApplication.Id > 0) {
      title = 'Application: ' + this.selectedApplication.ApplicationNumber
    } else if (this.property) {
      title = `Property: ${this.property.ParcelId}`
    } else if (this.contact) {
      title = `Contact: ${this.contact.FirstName} ${this.contact.LastName}`
    }
    return { title }
  },
  props: {},
  components: {
    ContactHeader,
    PropertyHeader,
    PropertyGrid,
    ContactEntryForm,
    PropertyEntryForm,
    ApplicationForm,
    ApplicationGrid,
    ApplicationDetails,
    FilingInstructions,
  },
  data() {
    return {
      expandHeader: false,
      dayjs,
      nextNav: null,
    }
  },
  computed: {
    ...get('luPeriod', [
      'currentLuPeriod',
      'errorMessage',
      'withinPeriod',
      'beforePeriod',
      'applicationDeadlineExpired',
      'applicationDeadlineExpiresSoon',
      'applicationsAccepted',
      'afterPeriod',
    ]),
    ...get('applicationDocumentType', ['applicationDocumentTypes']),
    ...get('application', [
      'selectedApplicationApplicationStatusHistories',
      'selectedApplicationApplicationDocuments',
      'selectedApplicationHouseholdMembers',
      'applicationStatusHistoriesLoading',
    ]),
    luPeriodLoading: get('luPeriod/loading'),
    ...get('application', ['selectedApplication']),
    applicationLoading: get('application/loading'),
    ...get('taxableProperty', ['selectedTaxableProperty']),
    taxablePropertyLoading: get('taxableProperty/loading'),
    ...get('contact', ['selectedContact']),
    contactLoading: get('contact/loading'),
    appId() {
      return parseInt(this.$route.params.appId) || false
    },
    contactId() {
      return parseInt(this.$route.query.contactId) || false
    },
    propertyId() {
      return parseInt(this.$route.query.propertyId) || false
    },
    canEdit() {
      let period = this.selectedApplication?.Period || this.currentLuPeriod
      let withinPeriod =
        dayjs(period.ApplicationOpenDate) <= dayjs() &&
        // modify so that no changes can be made after application deadline SCTASK0118168
        // dayjs(period.PeriodEndDate) >= dayjs()
        dayjs(period.ApplicationDeadline) >= dayjs()
      if (this.selectedApplication?.ApplicationStatusHistories?.length > 0) {
        var currentStatus =
          this.selectedApplication.ApplicationStatusHistories.reduce(
            (m, v, i) =>
              new Date(v.CreatedDate).getTime() >
                new Date(m.CreatedDate).getTime() && i
                ? v
                : m
          )
        if (
          // only allow changes during the period and while in incomplete status SCTASK0118168
          // currentStatus.StatusId == 3 ||
          // currentStatus.StatusId == 4 ||
          currentStatus.StatusId == 7
        ) {
          return withinPeriod
        } else return false
      } else return withinPeriod
    },
    canSubmit() {
      return (
        this.canEdit &&
        !this.beforePeriod &&
        !this.applicationDeadlineExpired &&
        !this.afterPeriod &&
        this.currentStatus?.StatusId == 7
      )
    },
    currentStatus() {
      if (
        this.selectedApplication.ApplicationStatusHistories &&
        this.selectedApplication.ApplicationStatusHistories.length > 0
      ) {
        return this.selectedApplication.ApplicationStatusHistories.reduce(
          (m, v, i) =>
            new Date(v.CreatedDate).getTime() >
              new Date(m.CreatedDate).getTime() && i
              ? v
              : m
        )
      }
      return null
    },
    currentStatusDescription() {
      if (this.currentStatus && this.currentStatus.Status) {
        return this.currentStatus.Status.Description
      }
    },
    payment1Timely() {
      if (
        this.selectedApplication.Payment1Date &&
        this.selectedApplication.Period.Payment1Deadline
      ) {
        return (
          new Date(this.selectedApplication.Payment1Date) <=
          new Date(this.selectedApplication.Period.Payment1Deadline)
        )
      } else {
        return false
      }
    },
    payment2Timely() {
      if (
        this.selectedApplication.Payment2Date &&
        this.selectedApplication.Period.Payment2Deadline
      ) {
        return (
          new Date(this.selectedApplication.Payment2Date) <=
          new Date(this.selectedApplication.Period.Payment2Deadline)
        )
      } else {
        return false
      }
    },
    fullPaymentTimely() {
      if (
        this.selectedApplication.Payment2Date &&
        this.selectedApplication.Period.FullPaymentDeadline &&
        this.selectedApplication.Payment1Date
      ) {
        return (
          new Date(this.selectedApplication.Payment2Date) <=
            new Date(this.selectedApplication.Period.FullPaymentDeadline) &&
          new Date(this.selectedApplication.Payment1Date) <=
            new Date(this.selectedApplication.Period.FullPaymentDeadline)
        )
      } else {
        return false
      }
    },
    paymentsMadeOnTime() {
      let fullPayment
      if (
        (this.payment1Timely && this.payment2Timely) ||
        this.fullPaymentTimely
      ) {
        fullPayment =
          this.selectedApplication.Payment1Amount +
          this.selectedApplication.Payment2Amount
      } else if (!this.payment1Timely && this.payment2Timely) {
        fullPayment = this.selectedApplication.Payment2Amount
      } else if (this.payment1Timely && !this.payment2Timely) {
        fullPayment = this.selectedApplication.Payment1Amount
      } else {
        return 0
      }
      return fullPayment
    },
    hasDocsForHousehold() {
      let incomeDocs = true
      this.selectedApplicationHouseholdMembers.forEach((value, index) => {
        let memberDoc = false
        if (value.ApplicationDocuments.length > 0) {
          this.getIncomeDocumentForHouseholdMembers.forEach((value, index) => {
            if (value.Id == 4 || value.Id == 5 || value.Id == 6) {
              memberDoc = true
            }
          })
        }
        if (!memberDoc) {
          incomeDocs = false
        }
      })
      return incomeDocs
    },
    filteredApplicationDocumentTypes() {
      return this.applicationDocumentTypes
        .filter((x) => x.IsRequired)
        .map((type) => {
          return type.DocumentType
        })
        .filter((x) => x.IsActive)
    },
    hasTaxDocs() {
      let hasDocument = true
      this.filteredApplicationDocumentTypes.forEach((type) => {
        let taxDoc = false
        if (this.selectedApplicationApplicationDocuments.length > 0) {
          taxDoc =
            this.selectedApplicationApplicationDocuments.findIndex(
              (x) => x.Document.DocumentTypeId == type.Id
            ) > -1
        }
        if (!taxDoc) {
          hasDocument = false
        }
      })
      return hasDocument
    },
    getIncomeDocumentForHouseholdMembers() {
      return this.applicationDocumentTypes
        .filter((x) => x.IsForHouseholdMember)
        .map((type) => {
          return type.DocumentType
        })
        .filter((x) => x.IsActive)
    },
    taxBillExceedsIncomePercentage() {
      if (
        this.selectedApplication.TotalHouseholdIncomeReported != null &&
        this.selectedApplication.TaxBillAmount != null &&
        this.selectedApplication.PropertyTaxGreaterThanIncomePercentage == true
      ) {
        var percentage =
          this.selectedApplication.TotalHouseholdIncomeReported * 0.1
        if (this.selectedApplication.TaxBillAmount > percentage) {
          return true
        } else {
          return false
        }
      } else {
        return null
      }
    },
    hasRequirements() {
      if (
        this.selectedApplication?.TaxableProperty?.Contact?.Ssn &&
        this.selectedApplication?.TaxableProperty?.ParcelId &&
        this.selectedApplication.TotalHouseholdIncomeReported != null &&
        this.selectedApplication.IsPrimaryResidence &&
        this.selectedApplication.DoResidentialRequirementsQualify &&
        (this.selectedApplication.DoHouseholdAssetsQualify ||
          this.taxBillExceedsIncomePercentage) &&
        this.selectedApplication.CertifySsn &&
        this.selectedApplication.UsResident &&
        this.selectedApplication.CorrectAndComplete &&
        this.paymentsMadeOnTime &&
        this.selectedApplicationHouseholdMembers.length > 0 &&
        this.selectedApplicationApplicationDocuments.length > 0 &&
        this.hasDocsForHousehold &&
        this.hasTaxDocs
      ) {
        return true
      } else {
        return false
      }
    },
    loading() {
      return (
        this.luPeriodLoading ||
        this.applicationLoading ||
        this.taxablePropertyLoading ||
        this.luPeriodLoading
      )
    },
    haveContact() {
      return this.contact && this.contact.Id > 0
    },
    haveProperty() {
      return this.property && this.property.Id > 0
    },
    haveApplication() {
      return this.selectedApplication && this.selectedApplication.Id > 0
    },
    contact() {
      if (this.appId && !this.loading) {
        return this.selectedApplication?.TaxableProperty?.Contact
      } else if (this.propertyId) {
        return this.selectedTaxableProperty.Contact
      } else if (this.contactId) {
        return this.selectedContact
      } else {
        return null
      }
    },
    //mapping list of properties
    contactProperties() {
      if (!this.loading) {
        if (this.contact?.TaxableProperties?.length > 0) {
          return this.contact.TaxableProperties.map((item) => {
            var latestPeriod = Math.max.apply(
              this,
              item.Applications.map((a) => a.Period.Period)
            )
            return {
              ...item,
              latestPeriod: latestPeriod > 0 ? latestPeriod : 'N/A',
            }
          })
        } else {
          return []
        }
      } else {
        return []
      }
    },
    property() {
      if (this.appId) {
        return this.selectedApplication.TaxableProperty
      } else if (this.propertyId) {
        return this.selectedTaxableProperty
      } else {
        return null
      }
    },
    // propertyApplications() {
    //   if (this.property && this.property.Applications.length > 0) {
    //     return this.property.Applications.map((a) => {
    //       return { ...a }
    //     })
    //   } else {
    //     return []
    //   }
    // },
    propertyApplicationsForCurrentPeriod() {
      if (!this.loading) {
        if (
          this.currentLuPeriod?.Id > 0 &&
          this.property?.Id > 0 &&
          this.property.Applications?.length > 0
        ) {
          var apps = this.property.Applications.filter(
            (x) =>
              x.PeriodId == this.currentLuPeriod.Id &&
              x.ApplicationStatusHistories.reduce((m, v, i) =>
                new Date(v.CreatedDate).getTime() >
                  new Date(m.CreatedDate).getTime() && i
                  ? v
                  : m
              ).StatusId != 8
          )
          return apps
        } else {
          console.devlog('nope')
          return []
        }
      } else {
        console.devlog('not loaded')
        return []
      }
    },
    currentApp() {
      var app
      this.contactProperties?.forEach((t) => {
        t?.Applications?.forEach((a) => {
          let appStatus = a.ApplicationStatusHistories.reduce((m, v, i) => {
            return m.CreatedDate
              ? new Date(v.CreatedDate).getTime() >
                  new Date(m.CreatedDate).getTime() && i
                ? v
                : m
              : v
          }, {})
          if (
            a.PeriodId == this.currentLuPeriod.Id &&
            appStatus.StatusId != 8
          ) {
            app = a
          }
        })
      })
      return app
    },
  },
  methods: {
    ...call('contact', ['saveContact', 'loadSelectedContact']),
    ...call('luPeriod', ['loadCurrentLuPeriod']),
    ...call('taxableProperty', [
      'saveTaxableProperty',
      'loadSelectedTaxableProperty',
    ]),
    ...call('application', [
      'saveApplication',
      'loadSelectedApplication',
      'setSelectedApplication',
    ]),
    goToNext() {
      if (this.nextNav) {
        this.nextNav()
      }
    },
    loadFromRoute() {
      if (!this.currentLuPeriod || !this.currentLuPeriod.Id > 0) {
        this.loadCurrentLuPeriod()
      }
      if (!this.appId) {
        this.setSelectedApplication({})
        if (this.contactId) {
          console.devlog('load contact ' + this.contactId)
          this.loadSelectedContact(this.contactId)
        }
        if (this.propertyId) {
          console.devlog('load property ' + this.propertyId)
          this.loadSelectedTaxableProperty(this.propertyId)
        }
      } else {
        console.devlog('load app ' + this.appId)
        this.loadSelectedApplication(this.appId)
      }
    },
    refreshContact() {
      this.loadFromRoute()
    },
    refreshProperty() {
      this.loadFromRoute()
    },
    refreshApplication() {
      this.loadFromRoute()
    },
    onBeforeUnload(e) {
      // console.purple(
      //   this.canEdit,
      //   this.beforePeriod,
      //   this.applicationDeadlineExpired,
      //   this.afterPeriod,
      //   this.currentStatus?.StatusId
      // )
      // console.pink(this.hasRequirements, this.canSubmit)
      var needsSubmit = this.hasRequirements && this.canSubmit
      // console.cyan(needsSubmit)
      if (needsSubmit) {
        e.preventDefault()
        e.returnValue = ''
      } else {
        delete e['returnValue']
      }
    },
  },
  watch: {
    propertyApplicationsForCurrentPeriod(nval, oval) {
      if (nval.length > 0 && this.$route?.params?.appId != nval[0]?.Id) {
        this.$router.push({
          name: 'consumerForm',
          params: { appId: nval[0].Id },
        })
      }
    },
    currentApp(nval, oval) {
      if (nval?.Id > 0 && this.$route?.params?.appId != nval.Id) {
        this.$router.push({ name: 'consumerForm', params: { appId: nval.Id } })
      }
    },
  },
  created() {
    this.loadFromRoute()
  },
  beforeRouteLeave(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    if (this.hasRequirements && this.canSubmit) {
      this.nextNav = next
      this.$refs.submitConfirm.deleteConfirm()
      // if (
      //   confirm(
      //     'You have not yet submitted your application. Do you still want to Exit?'
      //   )
      // ) {
      //   return next()
      // }
    } else {
      return next()
    }
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('beforeunload', this.onBeforeUnload)
    })
  },
}
</script>
<style scoped>
.deadline-alert {
  font-size: large;
  font-weight: 700;
  margin-right: 10px;
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 0%;
  border-width: 5px;
  border-color: var(--v-primary-base);
  border-style: double;
}
</style>
